module.exports = __webpack_public_path__ + "static/media/bf.4755cc0e.svg";